import React, { useState } from "react";
import { IconChevronRight } from "@tabler/icons-react";
import RoleToggle from "../../../components/RoleToggle";
import UniqueIdentifyCode from "./tabs/UniqueIdentifyCode";
import LeavesTab from "./tabs/LeavesTab";
import WorkingFromTab from "./tabs/WorkingFromTab";
import EmployeeShiftTab from "./tabs/EmployeeShiftTab";
import AttendanceBreakTab from "./tabs/AttendanceBreakTab";
import BiometricConfig from "./tabs/BiometricConfig";
import ActionsTab from "./tabs/ActionsTab";
import AttendanceTab from "./tabs/AttendanceTab";
import LoanAndAdvancesTab from "./tabs/LoanAndAdvancesTab";
import NoDataFound from "../../../components/common/NoDataFound";

const tabs = [
  "Unique Identify Code",
  "Attendance",
  "Attendance Break",
  "Working From",
  "Employee Shift",
  "Leaves",
  "Biometric Configuration",
  "Loan And Advances",
  "Knowledge Transfer",
  "Actions"
];

export default function HRSetting() {
  const [activeTab, setActiveTab] = useState("Unique Identify Code");

  return (
    <div className="w-full mx-auto mt-2 px-4 md:px-6 mb-20">
      <div className="flex justify-center items-center mt-4 mb-6">
        <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">
          HR Setting
        </h1>
      </div>

      {/* Tabs */}
      <div className="flex justify-center pb-4">
        <div className="whitespace-nowrap overflow-x-auto no-scrollbar">
          <RoleToggle
            options={tabs}
            active={activeTab}
            onChange={setActiveTab}
          />
        </div>
      </div>

      {/* Tab Content */}
      <div className="w-full">
        {activeTab === "Unique Identify Code" && <UniqueIdentifyCode />}
        {activeTab === "Attendance" && <AttendanceTab />}
        {activeTab === "Leaves" && <LeavesTab />}
        {activeTab === "Working From" && <WorkingFromTab />}
        {activeTab === "Employee Shift" && <EmployeeShiftTab />}
        {activeTab === "Attendance Break" && <AttendanceBreakTab />}
        {activeTab === "Biometric Configuration" && <BiometricConfig />}
        {activeTab === "Loan And Advances" && <LoanAndAdvancesTab />}
        {activeTab === "Actions" && <ActionsTab />}
        
        {/* Placeholder for un-implemented tabs */}
        {!["Unique Identify Code", "Attendance", "Leaves", "Working From", "Employee Shift", "Attendance Break", "Biometric Configuration", "Loan And Advances", "Actions"].includes(activeTab) && (
          <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] mx-auto max-w-5xl mt-2">
            <NoDataFound
              title="Coming Soon !!"
              message={`${activeTab} Working Are In-Progress`}
              mainClassName="rounded-3xl"
              subClassName="bg-transparent"
            />
          </div>
        )}
      </div>
    </div>
  );
}
